import styled, { css } from 'styled-components';

import { convertHexToRgbA } from '@shared/styled-system';

export enum ChipStatus {
	ACTIVE = 'active',
	PENDING = 'pending',
	ENDED = 'ended'
}

export const Wrapper = styled.div`
	margin-top: 24px;
`;

export const RecentPromotionsRow = styled.div`
	margin-bottom: 16px;

	.swiper-slide {
		width: 403px;
		height: auto !important;
	}
`;

export const TableHeader = styled.div`
	display: grid;
	grid-template-columns: repeat(4, 1fr);

	border: 1px solid ${({ theme }) => theme.colors.transparent.light10};
	border-top-left-radius: 12px;
	border-top-right-radius: 12px;
`;

export const TableHeaderItem = styled.div`
	padding: 16px 20px;

	font-size: 16px;
	line-height: 22px;
	font-weight: 600;
	color: ${({ theme }) => theme.colors.text.subtitle};

	@media (max-width: 992px) {
		padding: 16px 8px;
		font-size: 14px;
		line-height: 19px;
	}
`;

export const TableBody = styled.div`
	background-color: ${({ theme }) => theme.colors.background.secondary};
	border-bottom-left-radius: 12px;
	border-bottom-right-radius: 12px;
`;

export const TableRow = styled.div`
	display: grid;
	grid-template-columns: repeat(4, 1fr);
`;

export const PromotionName = styled.div`
	padding: 16px 20px;
	font-size: 14px;
	line-height: 19px;
	font-weight: 400;
	color: ${({ theme }) => theme.colors.text.alwaysWhite};
	align-self: center;
	display: flex;

	@media (max-width: 992px) {
		padding: 8px;
		font-size: 13px;
		line-height: 18px;
	}
`;

export const PromotionTicketCount = styled.div`
	padding: 16px 20px;
	font-size: 14px;
	line-height: 19px;
	font-weight: 400;
	color: ${({ theme }) => theme.colors.text.alwaysWhite};
	align-self: center;
	display: flex;
	gap: 8px;
	align-items: center;

	@media (max-width: 992px) {
		padding: 8px;
		font-size: 13px;
		line-height: 18px;
	}
`;

export const PromotionEndDate = styled.div`
	padding: 16px 20px;
	font-size: 14px;
	line-height: 19px;
	font-weight: 400;
	color: ${({ theme }) => theme.colors.text.alwaysWhite};
	align-self: center;
	display: flex;

	@media (max-width: 992px) {
		padding: 8px;
		font-size: 13px;
		line-height: 18px;
	}
`;

export const PromotionStatus = styled.div`
	padding: 16px 20px;
	font-size: 14px;
	line-height: 19px;
	font-weight: 400;
	color: ${({ theme }) => theme.colors.text.alwaysWhite};
	align-self: center;
	display: flex;
	display: inline-block;

	@media (max-width: 992px) {
		padding: 8px;
		font-size: 13px;
		line-height: 18px;
	}
`;

export const TicketIcon = styled.div`
	width: 20px;
	height: 20px;

	svg {
		width: 20px;
		height: 20px;
	}

	path {
		fill: ${({ theme }) => theme.colors.transparent.light50};
	}
`;

export const TablePagination = styled.div`
	display: flex;
	gap: 2px;
	padding: 10px 16px 16px;
	justify-content: end;
`;

export const TablePaginationButton = styled.div<{ $isActive: boolean }>`
	width: 34px;
	height: 34px;
	border-radius: 50%;
	cursor: pointer;

	display: flex;
	justify-content: center;
	align-items: center;

	font-size: 14px;
	line-height: 14px;
	font-weight: 600;
	color: ${({ theme }) => theme.colors.text.body};
	svg {
		width: 16px;
		height: 16px;
	}

	path {
		fill: ${({ theme }) => theme.colors.text.body};
	}

	${({ $isActive }) =>
		$isActive &&
		css`
			background-color: ${({ theme }) => theme.colors.transparent.light10};
			color: ${({ theme }) => theme.colors.text.alwaysWhite};
		`}
`;

export const StatusChip = styled.div<{ $status: ChipStatus }>`
	padding: 6px 8px;
	border-radius: 16px;
	display: inline-block;

	${({ $status }) =>
		$status === ChipStatus.ACTIVE
			? css`
					background-color: ${({ theme }) => convertHexToRgbA(theme.colors.control.secondary, 0.1)};
					color: ${({ theme }) => theme.colors.control.secondary};
				`
			: $status === ChipStatus.PENDING
				? css`
						background-color: ${({ theme }) => convertHexToRgbA(theme.colors.text.warning, 0.1)};
						color: ${({ theme }) => theme.colors.text.warning};
					`
				: $status === ChipStatus.ENDED &&
					css`
						background-color: ${({ theme }) => convertHexToRgbA(theme.colors.text.alwaysWhite, 0.1)};
						color: ${({ theme }) => theme.colors.text.alwaysWhite};
					`}
`;
